import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PageLoader from "components/PageLoader";

const LazyApplicant = lazy(() => import('pages/Applicant'));
const LazyApplicantDetail = lazy(() => import('pages/ApplicantDetail'));

function ApplicantRoute() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<LazyApplicant />} />
        <Route path="/:applicant_id" element={<LazyApplicantDetail />} />
      </Routes>
    </Suspense>
  );
}

export default ApplicantRoute;
